// src/components/leader/LoadError.js - a load failure with a retry that works (FL-07).
import React from 'react';
import { AlertCircle, RefreshCw } from 'lucide-react';
import { getErrorMessage } from '../../services/api';
import Button from '../ui/Button';

export default function LoadError({ error, title = 'Data se nepodařilo načíst', onRetry, retrying = false }) {
  return (
    <div className="rounded-lg border border-red-200 bg-white px-6 py-10 text-center">
      <AlertCircle className="mx-auto h-10 w-10 text-red-500" aria-hidden="true" />
      <h2 className="mt-3 text-base font-semibold text-gray-900">{title}</h2>
      <p role="alert" className="mx-auto mt-1 max-w-lg text-sm text-gray-700">
        {getErrorMessage(error)}
      </p>
      {onRetry && (
        <div className="mt-4">
          <Button onClick={() => onRetry()} loading={retrying}>
            <RefreshCw className="h-4 w-4" aria-hidden="true" />
            Zkusit znovu
          </Button>
        </div>
      )}
    </div>
  );
}
